module.exports = __webpack_public_path__ + "static/media/ic_star_selected.0ba4ffc8.svg";